import MainLayout from 'layouts/MainLayout';

const ClientDashboard = () => {
  return (
    <MainLayout>
      <div></div>
    </MainLayout>
  );
};

export default ClientDashboard;
